import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export function ShorthandProvider({ children }) {
  const [entries, setEntries] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/me/shorthands");
      setEntries(data || []);
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async (trigger, expansion, { kind = "typed", symbol = null } = {}) => {
    const { data } = await api.post("/me/shorthands", { trigger, expansion, kind, symbol });
    setEntries(e => [...e, data]);
    return data;
  };

  const update = async (entry_id, patch) => {
    await api.put(`/me/shorthands/${entry_id}`, patch);
    setEntries(e => e.map(x => x.entry_id === entry_id ? { ...x, ...patch } : x));
  };

  const remove = async (entry_id) => {
    await api.delete(`/me/shorthands/${entry_id}`);
    setEntries(e => e.filter(x => x.entry_id !== entry_id));
  };

  return <Ctx.Provider value={{ entries, create, update, remove, reload: load }}>{children}</Ctx.Provider>;
}

export const useShorthands = () => useContext(Ctx);
